import BaseView from './BaseView';
import PrivateHireSection from '../../components/PrivateHireSection';
import Modal from '../../components/Modal';

import { gsap } from "gsap";

let view = null;

class PrivateHire extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		new Modal();

		this.quickNav = this.container.querySelector('[data-quicknav-bar]');
		this.quickNavLinks = this.container.querySelectorAll('[data-quicknav-bar-link]');
		this.quickNavLinks.forEach((link) => {
			link.addEventListener('click', (evt) => {
				evt.preventDefault();

				const targetID = link.getAttribute('data-target-section');
				this.scrollToSection(targetID, 2);
			});
		});

		const intersectionMargins = '-49% 0% -49% 0%';
		this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
			rootMargin: intersectionMargins,
		});

		this.navSections = this.container.querySelectorAll('[data-hire-section]');
		this.navSections.forEach((section) => {
			this.intersectionObserver.observe(section);
            this.modules.push(new PrivateHireSection(section));
        });

		// Scroll to target Section when clicking Nav Menu (while alreay on hire)
        this.navLinks = document.querySelectorAll('[data-hire-nav-link]');
		this.boundHandleNavClick = this.handleNavClick.bind(this);
        this.navLinks.forEach(link => {
			link.addEventListener('click', this.boundHandleNavClick);
		});
	}

	handleIntersection(entries) {
		entries.forEach((entry) => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;

			// Section is in viewport
			if (ratio > 0) {
				const targetID = target.getAttribute('data-hire-section');
				this.setActiveLink(targetID);
			}
		});
	}

	setActiveLink(targetID) {
		const activeLink = this.quickNav.querySelector('[data-target-section="' + targetID + '"');
		if (activeLink) {
			this.quickNavLinks.forEach((link) => {
				link.classList.remove('is-active');
			});
			activeLink.classList.add('is-active');
		}
	}

	scrollToSection(targetID, duration = 0) {
		const targetSection = this.container.querySelector('[data-hire-section="' + targetID + '"');

		gsap.to(window, {
			duration: duration,
			ease: 'power2.inOut',
			scrollTo: {
				y: targetSection
			},
		});
	}

	destroy() {
		super.destroy();

		this.intersectionObserver.disconnect();

		this.navLinks.forEach(link => {
			link.removeEventListener('click', this.boundHandleNavClick);
		});
	}
}

export default {
	namespace: 'template-private-hire',
	beforeEnter: ({ current, next, trigger, four }) => {
		view = new PrivateHire(next.container);
		view.init();
	},
	afterEnter: ({ current, next, trigger, four }) => {
        view.afterEnterFunctions();
    },
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
